import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ROLE_ADMIN } from '../Optics/Constants/ConstantsOptics';
import { GET_FLOOD_ABON_LOG_API_URL, GET_FLOOD_PACKAGES_FULL_LOG_API_URL } from '../Optics/OpticApiConfig';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 
//     const response = await fetch("https://localhost:7073/api/Flood/GetPackagesBroadcast"); // Замените на

const Flood = (role) => {
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const token = localStorage.getItem('token');

  const fetchData1 = async () => {
    if (!token) {
      console.log('Ошибка! Токен не найден');
      return;
    }
    try {
      const response = await fetch(`${GET_FLOOD_PACKAGES_FULL_LOG_API_URL}`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
      
      const result = await response.json();
      setData1(result);
    } catch (error) {
      console.error("Ошибка загрузки данных GetPackagesBroadcast:", error);
    }
  };

  const fetchData2 = async () => {
    if (!token) {
      console.log('Ошибка! Токен не найден');
      return;
    }
    try {
      const response = await fetch(`${GET_FLOOD_ABON_LOG_API_URL}`,{
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      const result = await response.json();
      setData2(result);
    } catch (error) {
      console.error("Ошибка загрузки данных GetFloodAbonBroadcast:", error);
    }
  };

  useEffect(() => {
    fetchData1();
    fetchData2();
    const interval = setInterval(() => {
      fetchData1();
      fetchData2();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* <h2>Лог Broadcast-трафика</h2> */}
      <div style={{ display: 'flex', gap: '0px', marginTop: '10px' }}>

         { role.role === ROLE_ADMIN && (
        <div className="scroll-container" style={{ flex: 1, maxWidth: "550px", height: '80vh', overflowY: 'auto', paddingBottom: '10px' }}>
          <table border="1" className="results-table-flood">
            <thead>
              <tr>
               
                <th>IP</th>
                <th>Port</th>
                <th>Время события</th>
                <th>Broadcast Rx</th>
              </tr>
            </thead>
            <tbody>
              {data1.map((item) => (
                <tr key={item.id}>
                
                  <td>{item.ip}</td>
                  <td>{item.port}</td>
                  <td>{new Date(item.eventTime).toLocaleString()}</td>
                  <td>{item.broadcastRx.toLocaleString('ru-RU')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
         )}

        <div className="scroll-container" style={{ flex: 1, maxWidth: "950px", height: '80vh', overflowY: 'auto', paddingBottom: '10px' }}>
          <table border="1" className="results-table-flood">
            <thead>
              <tr>
                <th>ID</th>
                <th>IP</th>
                <th>Port</th>
                <th>Broadcast</th>
                <th>Время</th>
                <th>Время всплеска</th>
              </tr>
            </thead>
            <tbody>
              {data2.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.ip}</td>
                  <td>{item.port}</td>
                  <td
                    style={{
                      background: item.countBroadcast <= 10000
                        ? "linear-gradient(45deg, orange, gold)"
                        : "linear-gradient(45deg, #eb5b5b, #ff7979)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                    }}
                  >
                    +{item.countBroadcast.toLocaleString('ru-RU')}
                  </td>

                  <td>
                    <span
                      style={{
                        background: "linear-gradient(45deg, #74e291, #b1f1c2)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                      
                      }}
                    > 
                      {(() => {
                        const diffMs = new Date(item.endDate) - new Date(item.startDate);
                        const hours = Math.floor(diffMs / (1000 * 60 * 60));
                        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

                        let timeStr = [];
                        if (hours > 0) timeStr.push(`${hours} ч`);
                        if (minutes > 0) timeStr.push(`${minutes} мин`);
                        if (seconds > 0 || timeStr.length === 0) timeStr.push(`${seconds} сек`);

                        return timeStr.join(" ");
                      })()}
                    </span>
                  </td>

                  <td>с {new Date(item.startDate).toLocaleString()} по {new Date(item.endDate).toLocaleString()}</td>
                                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Flood;
